import { useNavigate } from "react-router";
import CreateBulkOrder from "./CreateBulkOrder";
import { useEffect, useState } from "react";
import selectors from "redux/Navigation/selectors";
import { useDispatch, useSelector } from "react-redux";
import { operations as navigationOperations } from "redux/Navigation";
import navOperations from "redux/Navigation/operations";
import { APIToReact } from "Service/BulkOrder/objectStructure";
import { useParams } from "react-router-dom";
import { getBulkOrderById, setBulkOrderById } from "Store/OrderManagement/BulkOrderById/BulkOrderByIdAction";
import { setSaveBulkOrder } from "Store/OrderManagement/BulkOrderSave/BulkOrderSaveAction";
import { showMyCartAlert } from "Store/Component/BulkOrder/BulkOrderAction";

const CreateBulkOrderContainer = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    
    const [showOrderTypeDetail, setShowOrderTypeDetail] = useState(false)
    const [SelectOrderType, setSelectOrderType] = useState('')
    const [showCart, setShowCart] = useState(false)
    const [vehicleRequest, setShowVehicleRequest] = useState(false)
    const [equipmentRequest, setEquipmentRequest] = useState(false)
    const [isEditOrder, setIsEditOrder] = useState(false);
    const [deletedItemFromCart, setdeletedItemFromCart] = useState<any>(null);
    const navDispatch = navigationOperations.dispatchNav(dispatch);
    const dispatchHeaderNav = navOperations.dispatchHeaderNav(dispatch);
    const {  headerNav, orderDetails, cartDetails, BulkOrdeByIdValue, showAlert }: any = useSelector((state?: any) => ({
      headerNav: selectors.GetHeaderNav(state),
      orderDetails: state.BulkOrderReducer.orderDetails,
      cartDetails: state.BulkOrderReducer.orderCartDetails,
      BulkOrdeByIdValue: state.BulkOrdeByIdReducer.bulkOrderbyIdValue,
      showAlert: state.BulkOrderReducer.showAlert
    }));
    const breadcrumbtitle = headerNav == "Home" ? "Home" : 'Bulk Orders'
    const breadcrumlist = [
        {
          text: breadcrumbtitle,
          key: "f1",
          href: "/ordermanagement",
          onClick: (e: any) => {
            e.preventDefault();
            navigateBack();
          },
        },
        { text: "Create Bulk Order", key: "f2" },
    ];

  const navigateBack = () => {
    if (headerNav == "Home") {
      navigate('/ordermanagement')
      navDispatch('Home');
      dispatchHeaderNav('Home');
    } else {
      navigate('/ordermanagement')
      navDispatch('Bulk Orders');
      dispatchHeaderNav('Bulk Orders');
    }
  } 

    const handleClickBack = () => {
      if(mobile) {
        if(showCartClicked){
          setShowCart(false)
          setShowCreateRequisition(true)   
          setShowCartClicked(false)      
        }
        else {
          setShowCart(true)
          setShowCreateRequisition(false)
          setShowCartClicked(true)   
          navigateBack();
        }
      }
      else {
        navigateBack();
      }       
    }

    const [mobile, setMobile] = useState(false);
    const [showCartClicked, setShowCartClicked] = useState(false)
    const [showCreateRequisition, setShowCreateRequisition] = useState(true)
  //  const [successAlert, setSuccessAlert] = useState(false);

  useEffect(() => {
    if (id) {
      if(BulkOrdeByIdValue?.orderId == id){
        APIToReact({
          dispatch,
          BulkOrdeByIdValue
        });
        setShowOrderTypeDetail(true);
        setShowCartClicked(true)
        setShowCart(true)
        setIsEditOrder(true);
      }
    }
  }, [BulkOrdeByIdValue]);

   //this id is orderId for draft mode
   let { id } = useParams();

   useEffect(() => {
     if (id != undefined) {
      dispatch(getBulkOrderById({
        orderId: id,
        isEdit: true
      }))
     }
     dispatch(setBulkOrderById(null))
     dispatch(setSaveBulkOrder({}))
   }, [id])

    useEffect(() => {
      const resizeFun = () => {
        if (window.innerWidth < 600) {    
          setMobile(true)
          if(showCartClicked){
            setShowCart(true)
            setShowCreateRequisition(false)         
          }
          else {
            setShowCart(false)
            setShowCreateRequisition(true)
          }
        }
        else {
          setMobile(false);
          if(showCartClicked){
            setShowCart(true)
            setShowCreateRequisition(true)
          }
          else {
            setShowCart(false)
            setShowCreateRequisition(true)
          }
          setShowCreateRequisition(true)
          //setShowCart(true)
        }
      }
      resizeFun();
  
      window.addEventListener('resize', resizeFun)
  
      return () => window.removeEventListener('resize',resizeFun)
    },[showCartClicked]);
    
    const mycartButton = () => {
      setShowCartClicked(true)
      setShowCart(true);
      setShowCreateRequisition(false)
    //  setSuccessAlert (false)
    }
  
    useEffect(() => {
      document.getElementsByClassName('content-wrapper')[0].scrollTop = 0;
    }, []);

    useEffect(() => {
      if(cartDetails?.length >= 1 && cartDetails != undefined){
        setShowCart(true)
      }else{
        setShowCart(false)
      }
    },[cartDetails])

    useEffect(() => {
      if(showAlert?.isSucessfull){
        setTimeout(() => {
            dispatch(showMyCartAlert(false, ''))
        }, 5000)
      }
    }, [showAlert?.isSucessfull])

    const dismissAlert = () => {
      dispatch(showMyCartAlert(false, ''))
    }

  const getCartCount = () => {
    let count = 0
    cartDetails?.map((itemVal?: any, itemIndex?: any) => {
      count = count + itemVal?.requests?.length
    })
    return count
  }
  
    return <CreateBulkOrder 
                breadcrumlist={breadcrumlist} 
                handleClickBack={handleClickBack}
                showOrderTypeDetail={showOrderTypeDetail}
                setShowOrderTypeDetail={setShowOrderTypeDetail}
                SelectOrderType={SelectOrderType}
                setSelectOrderType={setSelectOrderType}
                mycartButton={mycartButton}
                showCart={showCart}
                setShowCart={setShowCart}
                showCartClicked={showCartClicked}
                setShowCartClicked={setShowCartClicked}
                mobile={mobile}
                setMobile={setMobile}                
                showCreateRequisition={showCreateRequisition}
                setShowCreateRequisition={setShowCreateRequisition}
                vehicleRequest={vehicleRequest}
                setShowVehicleRequest={setShowVehicleRequest}
                equipmentRequest={equipmentRequest}
                setEquipmentRequest={setEquipmentRequest}
                orderDetails={orderDetails}
                isEditOrder={isEditOrder}
                showAlert={showAlert}
                dismissAlert={dismissAlert}
                getCartCount = {getCartCount}
                setdeletedItemFromCart = {setdeletedItemFromCart}
                deletedItemFromCart = {deletedItemFromCart}
            />
}

export default CreateBulkOrderContainer;